import { z } from 'zod';

const KEY_PREFIX = 'narvar:rm:disco:visit:';

export const VISIT_GAP_MS = 4 * 60 * 60 * 1000;

const VisitRecordSchema = z.object({
  visit: z.number().int().positive(),
  lastVisitId: z.string(),
  lastSeenAt: z.number(),
});

export type VisitRecord = z.infer<typeof VisitRecordSchema>;

const store = (): Storage | undefined => {
  if (typeof window === 'undefined') return undefined;
  try {
    return window.localStorage;
  } catch (err) {
    console.error('Error reading localStorage', err);
    return undefined;
  }
};

export function readVisitRecord(orderKey: string): VisitRecord | null {
  const storage = store();
  if (!storage) return null;
  try {
    const raw = storage.getItem(`${KEY_PREFIX}${orderKey}`);
    if (!raw) return null;
    const parsed = VisitRecordSchema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : null;
  } catch (err) {
    console.error('Error reading Disco visit history', err);
    return null;
  }
}

export function writeVisitRecord(orderKey: string, record: VisitRecord): void {
  const storage = store();
  if (!storage) return;
  try {
    storage.setItem(`${KEY_PREFIX}${orderKey}`, JSON.stringify(record));
  } catch (err) {
    console.error('Error writing Disco visit history', err);
  }
}

export function visitForPageLoad(
  record: VisitRecord | null,
  visitId: string,
  now: number,
): number {
  if (!record) return 1;
  if (record.lastVisitId === visitId) return record.visit;
  return now - record.lastSeenAt > VISIT_GAP_MS
    ? record.visit + 1
    : record.visit;
}
